import React, { useMemo, useCallback } from 'react';
import type { MenuProps } from 'antd';
import { Dropdown, Button } from 'antd';

type GenericDropdownProps<T> = {
  value: T;
  onChange: (value: T) => void;
  items: T[];
  renderItem: (item: T) => React.ReactNode;
  title: string;
  className?: string;
};

//This componnet is used for rending list in drop-down format Ex: Line style types, line width
const GenericDropdown = <T extends string | number>({
  value,
  onChange,
  items,
  renderItem,
  title,
  className,
}: GenericDropdownProps<T>) => {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      // dataset에서 읽은 값은 항상 문자열 타입이므로 strokeWidth와 같이 숫자 타입이 기대되는 경우 zod error 발생 가능
      // 원본 item에서 문자열 비교로 정확한 값을 찾아서 반환해야 함.
      const stringValue = e.currentTarget.dataset.value;
      const original = items.find(item => String(item) === stringValue);
      if (original !== undefined) {
        onChange(original);
      }
    },
    [items, onChange],
  );

  const menuItems: MenuProps['items'] = useMemo(
    () =>
      items.map(item => ({
        key: item,
        label: (
          <a onClick={handleClick} data-value={item}>
            {renderItem(item)}
          </a>
        ),
      })),
    [handleClick, items, renderItem],
  );

  return (
    <Dropdown menu={{ items: menuItems }} trigger={['click']} className={className}>
      <Button title={title}>{renderItem(value)}</Button>
    </Dropdown>
  );
};

export default GenericDropdown;
